// Display name for a user whose `name` may be empty (signup is email + password only,
// so the backend can store name === ""). Falls back to the email local-part (before @),
// never a blank. Treats whitespace-only names as empty.
export function userDisplayName(
  user: { name?: string | null; email?: string | null } | null | undefined,
): string {
  const name = (user?.name || "").trim();
  if (name) return name;
  const email = (user?.email || "").trim();
  return email ? email.split("@")[0] : "there";
}
